export const defaultQuestionTitle = 'Click to add question'
export const defaultHeadingTitle = 'Click to add heading'
